<script setup>
import AutocompleteFilter from '@/components/widgets/AutocompleteFilter.vue';
import { ref, inject, onMounted, watch } from 'vue';

const backendApi = inject('backendApi');

const props = defineProps({
    hideLabel: {
        type: Boolean,
        default: false
    },
    documentType: {
        default: null
    }
});
const emit = defineEmits(['update', 'update:focused']);

const selected = ref(null);
const loading = ref(true);
const agents = ref([]);
const showRetryButton = ref(false);
const searchQuery = ref('');

const getAgents =() => {
    cleanData();

    backendApi()
        .label()
        .index({
            documentType: props.documentType,
            pattern: searchQuery.value
        })
        .then(success, fail)
        .finally(() => (loading.value = false));

    function success(response) {
        agents.value = response.data;
    }

    function fail() {
        showRetryButton.value = true;
    }
};

watch(
    () => props.documentType,
    () => {
        selected.value = null;
        getAgents();
    }
);

const cleanData = () => {
    agents.value = [];
    loading.value = true;
    showRetryButton.value = false;
};

onMounted(() => getAgents());
</script>

<template>
    <AutocompleteFilter
        v-model="selected"
        v-model:search="searchQuery"
        :items="agents"
        item-title="name"
        item-value="id"
        :label="hideLabel ? '' : $t('Agent')"
        :loading="loading"
        :show-retry-button="showRetryButton"
        @update="emit('update', selected)"
        @preparing-search="cleanData"
        @search="getAgents"
        @retry="getAgents"
        @update:focused="(state) => emit('update:focused', state)"
    >
        <template v-slot:default="{ props, item }">
            <v-list-item
                v-bind="props"
                :title="`${item.raw.name}`"
            ></v-list-item>
        </template>
        <template v-if="$slots.prepend" v-slot:prepend>
            <slot name="prepend"></slot>
        </template>
    </AutocompleteFilter>
</template>
